import { SupportedLanguages } from './typesForCommonLib';

const langToLocale: { [key in SupportedLanguages]: string } = {
    no: 'nb-NO',
    en: 'en-US',
    fi: 'fi-FI',
    da: 'da-DK',
};

export function formatDate({
    date,
    formatType,
    lang,
}: {
    date: string;
    formatType:
        | 'timeOnly'
        | 'fullDateWithWeekdayAndMonth'
        | 'longDateWithWeekday'
        | 'numericDate';
    lang?: SupportedLanguages;
}): string {
    const userLocale = navigator.language || 'en-US';
    const formattedDate = new Date(date);
    const locale = lang ? langToLocale[lang] : userLocale;

    let options: Intl.DateTimeFormatOptions;

    switch (formatType) {
        case 'timeOnly':
            options = {
                hour: '2-digit',
                minute: '2-digit',
            };
            break;
        case 'fullDateWithWeekdayAndMonth':
            options = {
                weekday: 'short', // "Søn" for Sunday
                day: '2-digit', // "29"
                month: 'long', // "desember"
                year: 'numeric', // "2024"
            };
            break;
        case 'numericDate':
            options = {
                year: 'numeric', // "2024"
                month: '2-digit', // "12"
                day: '2-digit', // "29"
            };
            break;
        case 'longDateWithWeekday':
        default:
            options = {
                weekday: 'short', // "Søn"
                day: '2-digit', // "29"
                month: 'long', // "desember"
                year: 'numeric', // "2024"
            };
            break;
    }

    return new Intl.DateTimeFormat(locale, options).format(formattedDate);
}
